var cio_ui_templates = require("ui-templates");

var SplitView = function(parentView, width, configuration) {

    this.parentView = parentView;
    this.template = this.parentView.addSplit(width);
    this.configuration = configuration;
};

SplitView.prototype.getTemplate = function(name){

    if(name == 'split_left'){
        return this.getLeftSplitItem();
    }else if(name == 'split_right'){
        return this.getRightSplitItem();
    }else if(name == 'split_middle'){
        return this.getMiddleSplitItem();
    }
}

SplitView.prototype.getLeftSplitItem = function(){
    if(!this._leftSplitItem){
        this._leftSplitItem = this.template.addLeftSplitItem();
    }
    return this._leftSplitItem;
}

SplitView.prototype.getMiddleSplitItem = function(){
    if(!this._middleSplitItem){
        this._middleSplitItem = this.template.addMiddleSplitItem();
    }
    return this._middleSplitItem;
}

SplitView.prototype.getRightSplitItem = function(){
    if(!this._rightSplitItem){
        this._rightSplitItem = this.template.addRightSplitItem();
    }
    return this._rightSplitItem;
}

SplitView.prototype.getSwitcher = function (name, canNotEdit) {
    if(name == 'split_left'){
        return this.getLeftSplitItem().addSwitcher(canNotEdit);
    }else if(name == 'split_right'){
        return this.getRightSplitItem().addSwitcher(canNotEdit);
    }
};

module.exports = SplitView;
